import type { TOC } from "@ember/component/template-only";

interface ChevronDownSignature {
  Element: SVGElement;
}

const ChevronDown: TOC<ChevronDownSignature> = <template>
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke="currentColor"
    stroke-width="1"
    ...attributes
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
</template>;

export default ChevronDown;
